<div *ngIf="initialized" id="trainer-new-container" class="container">
    <h1>{{'add-new-trainer' | translate}}</h1>
    <trainer-detail-description
            [trainer]="trainer"
            (onTrainerSaved)="onTrainerSaved($event)"
            [availableLanguages]="availableLanguages"
    ></trainer-detail-description>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/create/create.component.html